import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import type MenuItem from 'ui/src/data/MenuItem';
import { useMobileHeader } from './hooks/useMobileHeader';
import MobileMenuItem from './MobileMenuItem';
import useMobileHeaderTheme from './themes';

export interface MobileMenuListSectionProps {
  mobileSectionTitle?: string;
  menuItems: MenuItem[];
}

export default function MobileMenuListSection({ mobileSectionTitle, menuItems }: MobileMenuListSectionProps) {
  const { mobileMenuSectionTitleClasses } = useMobileHeaderTheme();
  const { mobileMenuActiveItem, toggleMobileMenuActiveItem } = useMobileHeader();

  return (
    <>
      {mobileSectionTitle && <span className={twMerge(mobileMenuSectionTitleClasses)}>{mobileSectionTitle}</span>}
      <ul>
        {menuItems.map((menuItem) => (
          <MobileMenuItem
            key={menuItem.id}
            menuItem={menuItem}
            mobileMenuActiveItem={mobileMenuActiveItem}
            toggleMobileMenuActiveItem={toggleMobileMenuActiveItem}
          />
        ))}
      </ul>
    </>
  );
}
